<template>
    <offerDetail />
</template>

<script>
//Components
import offerDetail from "@/app/components/offer-detail/offer-detail"
export default {
    name:"Offer-detail-view",
    components: { offerDetail }
}
</script>

<style>

</style>